import React from 'react';
import cx from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import blue from '@material-ui/core/colors/blue';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

export type AlertType = 'success' | 'warning' | 'danger' | 'info';

const variantIcon: { [key in AlertType]: React.ComponentType<SvgIconProps> } = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  danger: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    success: {
      backgroundColor: theme.palette.ok.dark,
    },
    danger: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: blue[700],
    },
    warning: {
      backgroundColor: theme.palette.warning.dark,
    },
    alert: {
      marginBottom: theme.spacing(0.25),
      maxWidth: 'initial',
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
);

export interface Props {
  action?: React.ReactNode;
  className?: string;
  message?: React.ReactNode;
  variant?: AlertType;
}

export const Alert: React.FC<Props> = props => {
  const { action, className, message, variant } = props;
  const classes = useStyles();
  const alertVariant = variant || 'info';
  const Icon = variantIcon[alertVariant];

  return (
    <SnackbarContent
      action={action}
      className={cx(classes.alert, classes[alertVariant], className)}
      message={
        <span className={classes.message}>
          <Icon className={classes.iconVariant} />
          {message}
        </span>
      }
    />
  );
};

export default Alert;
